import { Icon } from '@iconify/react/dist/iconify.js'
import "./style.css"
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { ICheckbox } from './Checkbox.type'

const CheckBox: FC<ICheckbox> = ({ setValue, value, label, className, disabled }) => {
    const { t } = useTranslation()

    return (
        <div className={`checkbox-container col-12 ${className} ${disabled && "disabled"}`}>
            {label ? <label className='checkbox-label'>
                {t(label)}
            </label>
                : ""}
            <div className='checkbox-section' onClick={() => !disabled && setValue(!value)}>
                <div className={`${value && "checked"} checkbox`}>
                    {value && <Icon icon="fe:check" className='checkbox-Icon' />}
                </div>
            </div>
        </div>
    )
}

export default CheckBox